import { doc, increment, updateDoc } from 'firebase/firestore';
import { DB } from './firestore';

export const incrimentReferal = async (refCode: string) => {
	const ambasRef = doc(DB, 'ambassadeurs', refCode);
	await updateDoc(ambasRef, {
		codeUsed: increment(1),
	});
};
